// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"s1N4s2IAhGBKIrbng5u9"};